import { Link } from "react-router-dom";

import { PrivateTick } from "components/buttons";
import { Image } from "components";
import BROKEN_ICON from "components/icons/image_icon.svg";

import "./RawCollectionTile.scss";

export const RawCollectionTile = (props: {
  link: string;
  thumbnail: string;
  published: boolean;
  label: string;
}): JSX.Element => {
  return (
    <div className="tile">
      <Link to={props.link}>
        <Image
          className="thumbnail"
          src={props.thumbnail || BROKEN_ICON}
        />

        {!props.published && <PrivateTick />}
      </Link>

      <div className="title" title={props.label}>
        {props.label}
      </div>
    </div>
  );
};
